import React from 'react';
import PaginatedPrioritySection from './PaginatedPrioritySection';
import EditableText from './EditableText';

export default function TopStrengthsPage({ data, personName, startPageNumber }) {
  const header = (
    <>
      <h2 className="pdf-section-heading pdf-section-heading--numbered">
        <span className="pdf-section-heading__badge">2</span>
        <EditableText
          as="span"
          path="topStrengths.sectionHeading"
          variant="inline"
          stripInlineWrap
        />
      </h2>
      <EditableText
        as="div"
        className="pdf-body-text"
        path="topStrengths.topStrengthsReport"
        variant="block"
      />
    </>
  );

  return (
    <PaginatedPrioritySection
      header={header}
      tableContents={data.tableContents}
      legendKeys={data.tableContents && data.tableContents.legendKeys && data.tableContents.legendKeys}
      summaryContentPath="topStrengths.topStrengthsContent"
      slicePageContent="topStrengths"
      sectionKey="topStrengths"
      startPageNumber={startPageNumber}
      personName={personName}
    />
  );
}
